export default class ProductTemplate {
  id ?: string;

  productId: number;

  description: string;

  observation ?: string;

  hasCalculationRules: boolean;

  lastModifiedDate: string;

  datasourceId ?: string;

  constructor(obj: any = {}) {
    this.id = obj.id || null;
    this.productId = obj.productId || 0;
    this.description = obj.description || '';
    this.observation = obj.observation || null;
    this.hasCalculationRules = obj.hasCalculationRules || false;
    this.lastModifiedDate = obj.lastModifiedDate || '';
    this.datasourceId = obj.datasourceId || null;
  }

  public static of(obj: any = {}): ProductTemplate {
    return new ProductTemplate(obj || {});
  }

  public static ofList(obj: any[]): ProductTemplate[] {
    return obj.map(this.of);
  }
}
